import React, { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import format from "date-fns/format";
import { LinearProgress } from "@material-ui/core";
import Accordion from "@material-ui/core/Accordion";
import AccordionSummary from "@material-ui/core/AccordionSummary";
import AccordionDetails from "@material-ui/core/AccordionDetails";
import ExpandMoreIcon from "@material-ui/icons/ExpandMore";
import {
  GetApp as GetAppIcon,
  Description as DescriptionIcon,
  VerifiedUser as VerifiedUserIcon,
  Build as BuildIcon,
  WhatsApp as WhatsAppIcon
} from "@material-ui/icons";

import "../styles/pages/tracking.css";
import logoCasa from "../images/casa-logo.svg";
import iconEntrega from "../images/car-black-icon.svg";
import iconMontagem from "../images/tools-icon.svg";
import iconImpermeabilizacaoSofa from "../images/waterproof-sofa.png";
import iconImpermeabilizacaoChair from "../images/waterproof-chair.png";
import iconImpermeabilizacaoArmchair from "../images/waterproof-armchair.png";
import api from "../services/api";
import { orderProps } from "../interfaces/index";
import PrincipalLoader from "../components/PrincipalLoader";
import ServicosAbraCasa from "../components/ServicosAbraCasa";
import ServicosTeaser from "../components/ServicosTeaser";
import { formatCpfCnpj, maskCpf } from "../utils";

interface paramsTracking {
  orderId: string;
}

const inicialState = {
  order: {
    orderStatus: {
      chave: 0,
      codigo: "",
      descricao: "",
      created_at: "",
      updated_at: "",
    },
    chave: 0,
    orderId: "",
    sequence: "",
    emissao: "",
    hashURL: "",
    status: 0,
    created_at: "",
    dataEntrega: "",
    updated_at: 0,
    loja: "",
    valor: 0,
    previsaoEntrega: "",
    isPromocao: false,
    chCriacao: 0,
    pedidoDet: [],
    docCliente: "",
    nomeCliente: ""
  },
  logsEntrega: [],
};

// Motivos de contato pré-configurados para WhatsApp
const contactReasons = [
  // {
  //   title: "Dúvida sobre entrega",
  //   message: "Olá! Tenho uma dúvida sobre a entrega do meu pedido."
  // },
  // {
  //   title: "Problema com produto",
  //   message: "Olá! Estou com um problema relacionado ao produto do meu pedido."
  // },
  // {
  //   title: "Cancelar pedido",
  //   message: "Olá! Gostaria de cancelar meu pedido."
  // },
  // {
  //   title: "Nota fiscal",
  //   message: "Olá! Preciso de ajuda com a nota fiscal do meu pedido."
  // },
  {
    title: "Preciso de ajuda",
    message: "Olá! Preciso de ajuda."
  }
];

const whatsappNumber = "5521971174398"; // (21) 97117-4398

function Tracking() {
  const { orderId } = useParams<paramsTracking>();
  const [loading, setLoading] = useState(false);
  const [orderInfo, setOrderInfo] = useState<orderProps>(inicialState);
  const [isLoading, setIsLoading] = useState(true);
  const [nfeLoading, setNfeLoading] = useState<{ [key: number]: boolean }>({});
  const [nfeLinks, setNfeLinks] = useState<{ [key: number]: string }>({});
  const [certLinks, setCertLinks] = useState<{ [key: number]: string }>({});
  const [certLoading, setCertLoading] = useState<{ [key: number]: boolean }>({});
  const [manualLinks, setManualLinks] = useState<{ [key: number]: string }>({});
  const [manualLoading, setManualLoading] = useState<{ [key: number]: boolean }>({});
  const [openHelloModal, setOpenHelloModal] = useState(false);
  const [rotaInfo, setRotaInfo] = useState<{ [key: number]: { data: string; horario: string } }>({});
  const [montagemInfo, setMontagemInfo] = useState<{ [key: number]: string }>({});
  const [expandedProducts, setExpandedProducts] = useState<{ [key: number]: boolean }>({});

  function setProductExpanded(chave: number, expanded: boolean) {
    setExpandedProducts(prev => ({ ...prev, [chave]: expanded }));
  }

  function collapseProductFromFooter(chave: number, index: number) {
    setProductExpanded(chave, false);

    // Ao fechar pelo rodapé de um card longo, o topo dele pode ficar fora da tela
    const header = document.getElementById(`panel${index}-header`);
    if (header && header.getBoundingClientRect().top < 0) {
      header.scrollIntoView({ behavior: "smooth", block: "start" });
    }
  }
  const blockedDeliveryTransp = [
    1708755849,
    1693546217,
    1708755853,
    1695195433,
    1708755854,
    1693546221,
    1708755852,
    1693546219,
    1693546220,
    1708755850
  ]

  const deliveredCouries = [301, 427, 9, 462, 475, 543, 544, 545, 546];

  async function fetchData() {
    try {
      setLoading(true);
      const response = await api.get(`/acompanhamento/${orderId}`);

      setTimeout(() => {
        setOrderInfo(response.data);
        setLoading(false);
      }, 1000);
    } catch (error) {
      console.error(error);
      setLoading(false);
    }
  }

  useEffect(() => {
    fetchData();
    setIsLoading(false);
  }, []);

  // Buscar certificado e manual automaticamente quando os produtos forem carregados
  useEffect(() => {
    if (!orderInfo.order.pedidoDet || orderInfo.order.pedidoDet.length === 0) return;

    orderInfo.order.pedidoDet.forEach((product) => {
      const productLogs = orderInfo.logsEntrega.filter(
        (log) => log.chItemPed === product.chave
      );

      const isFat = isFaturado(productLogs);

      // Buscar certificado se produto estiver faturado e tiver código
      if (isFat && product.codigo) {
        // Verificar se já não está carregando e se já não tem o link
        const alreadyHasLink = certLinks[product.chave];
        const alreadyLoading = certLoading[product.chave];

        if (!alreadyHasLink && !alreadyLoading) {
          fetchCert(product.chave, product.codigo);
        }
      }

      // Buscar manual se produto estiver faturado e tiver código
      if (isFat && product.codigo) {
        // Verificar se já não está carregando e se já não tem o link
        const alreadyHasLink = manualLinks[product.chave];
        const alreadyLoading = manualLoading[product.chave];

        if (!alreadyHasLink && !alreadyLoading) {
          fetchManual(product.chave, product.codigo);
        }
      }
    });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [orderInfo.order.pedidoDet, orderInfo.logsEntrega]);

  function formatCurrency(value: number, totalValue: boolean = false) {
    return new Intl.NumberFormat("pt-BR", {
      style: "currency",
      currency: "BRL",
    }).format(totalValue ? value / 100 : value);
  }

  function formatDate(date: string | number) {
    if (!date) return "";
    try {
      const dateObj = typeof date === "string" ? new Date(date) : new Date(date * 1000);
      return format(dateObj, "dd/MM/yyyy");
    } catch {
      return "";
    }
  }

  function formatDateTime(date: string) {
    if (!date) return "";

    try {
      const [datePart, timePart] = date.split(" ");

      const [year, month, day] = datePart.split("-");
      const [hour, minute, second] = timePart.split(":");

      const dateObj = new Date(
        Number(year),
        Number(month) - 1,
        Number(day),
        Number(hour),
        Number(minute),
        Number(second || 0)
      );

      // adiciona 3 horas
      dateObj.setHours(dateObj.getHours() + 3);

      const formattedDay = String(dateObj.getDate()).padStart(2, "0");
      const formattedMonth = String(dateObj.getMonth() + 1).padStart(2, "0");
      const formattedYear = dateObj.getFullYear();

      const formattedHour = String(dateObj.getHours()).padStart(2, "0");
      const formattedMinute = String(dateObj.getMinutes()).padStart(2, "0");

      return `${formattedDay}/${formattedMonth}/${formattedYear} às ${formattedHour}:${formattedMinute}`;
    } catch {
      return "";
    }
  }

  function openWhatsApp(message: string) {
    const encodedMessage = encodeURIComponent(message);
    const url = `https://wa.me/${whatsappNumber}?text=${encodedMessage}`;
    window.open(url, "_blank");
  }

  const cnpjsToNFE = [
    '26796309000123',  /* zeni */
    '34859169000202',  /* juma */
    '10935713000109', /* eco */
    '10474874000134', /* trip */
    '34859169000113', /* juma comercio */
    '10406052000116' /* gaia */
  ];

  async function getNFE(chave: number, chItemPed: number, transportadora: string, productKey: number) {
    if (nfeLinks[productKey]) {
      window.open(nfeLinks[productKey], "_blank");
      return;
    }

    setNfeLoading({ ...nfeLoading, [productKey]: true });
    try {
      const response = await api.post("/linknfe", {
        chave,
        chItemPed,
        transportadora
      });

      if (response.data.nfe) {
        setNfeLinks({ ...nfeLinks, [productKey]: response.data.nfe });
        window.open(response.data.nfe, "_blank");
      }
    } catch (error) {
      console.error("Erro ao buscar NFE:", error);
      alert("Erro ao buscar nota fiscal. Tente novamente mais tarde.");
    } finally {
      setNfeLoading({ ...nfeLoading, [productKey]: false });
    }
  }

  function canFetchNFE(log: any) {
    if (!log.chNFE) return false;
    if (log.linkNFE) return false;
    if (!log.cnpjEmissorNFE) return false;
    return cnpjsToNFE.includes(log.cnpjEmissorNFE);
  }

  function isFaturado(productLogs: any[]) {
    return productLogs.some(log => log.chNFE);
  }

  async function fetchCert(productKey: number, codigo: string) {
    setCertLoading({ ...certLoading, [productKey]: true });
    try {
      const code = codigo ? codigo.toLowerCase() : "";
      if (!code) {
        setCertLoading({ ...certLoading, [productKey]: false });
        return;
      }
      const response = await api.get(`/linkCertificado/${code}`);
      const data = response?.data;
      let certificado = "";
      if (Array.isArray(data)) {
        certificado = data[0]?.certificado ?? data[0]?.link ?? "";
      } else if (data && typeof data === 'object') {
        certificado = data.certificado ?? data.link ?? "";
      }
      if (certificado) {
        setCertLinks({ ...certLinks, [productKey]: certificado });
      }
    } catch (error) {
      console.error("Erro ao buscar certificado:", error);
    } finally {
      setCertLoading({ ...certLoading, [productKey]: false });
    }
  }

  async function fetchManual(productKey: number, codigo: string) {
    setManualLoading({ ...manualLoading, [productKey]: true });
    try {
      const code = codigo ? codigo.toLowerCase() : "";
      if (!code) {
        setManualLoading({ ...manualLoading, [productKey]: false });
        return;
      }
      const response = await api.get(`/manualMontagem/${code}`);
      const data = response?.data;
      let manual = "";
      if (Array.isArray(data)) {
        manual = data[0]?.manual ?? data[0]?.link ?? "";
      } else if (data && typeof data === 'object') {
        manual = data.manual ?? data.link ?? "";
      }
      if (manual) {
        setManualLinks({ ...manualLinks, [productKey]: manual });
      }
    } catch (error) {
      console.error("Erro ao buscar manual:", error);
    } finally {
      setManualLoading({ ...manualLoading, [productKey]: false });
    }
  }

  function getProductImage(urlImage?: string) {
    if (!urlImage) return "https://abramais.vteximg.com.br/arquivos/ids/221911-600-600/noah-cinza-claro.jpg?v=638500760541870000";
    return urlImage;
  }

  function getStatusIcon(status: number) {
    // Ícones baseados no status da entrega
    if (status === 314) return "🚚"; // Entregue a transportadora
    if (deliveredCouries.includes(status)) return "✅"; // Entregue
    if (status === 7) return "❌"; // Cancelado
    return "📦"; // Em preparação
  }

  function capitalizeWords(str?: string) {
    if (!str) return "";
    return str
      .toLowerCase()
      .trim()
      .split(/\s+/)
      .map(word => {
        if (word.length === 1) {
          // palavra de 1 letra → manter minúscula
          return word.toLowerCase();
        }
        return word.charAt(0).toUpperCase() + word.slice(1);
      })
      .join(" ");
  }

  function formatDateFromString(dateString: string) {
    if (!dateString) return "";

    // Caso já esteja no formato DD/MM/YYYY
    if (dateString.includes("/")) return dateString;

    // Extrai apenas a parte da data (YYYY-MM-DD)
    const [year, month, day] = dateString.split("T")[0].split("-");

    return `${day}/${month}/${year}`;
  }

  function parseDateValue(dateString?: string): Date | null {
    if (!dateString) return null;

    try {
      if (dateString.includes("/")) {
        const [dia, mes, ano] = dateString.split("/");
        const parsedDate = new Date(`${mes}/${dia}/${ano}`);
        return isNaN(parsedDate.getTime()) ? null : parsedDate;
      }

      const parsedDate = new Date(dateString);
      return isNaN(parsedDate.getTime()) ? null : parsedDate;
    } catch {
      return null;
    }
  }

  function getDaysDifference(startDate?: string, endDate?: string): number | null {
    const start = parseDateValue(startDate);
    const end = parseDateValue(endDate);

    if (!start || !end) return null;

    start.setHours(0, 0, 0, 0);
    end.setHours(0, 0, 0, 0);

    const millisecondsPerDay = 1000 * 60 * 60 * 24;
    return Math.round((end.getTime() - start.getTime()) / millisecondsPerDay);
  }

  function getImpermeabilizacaoIcon(descricao: string) {
    const descLower = descricao?.toLowerCase() || "";
    if (descLower.includes("cadeira")) {
      return iconImpermeabilizacaoChair;
    }
    if (descLower.includes("poltrona")) {
      return iconImpermeabilizacaoArmchair;
    }
    return iconImpermeabilizacaoSofa;
  }

  function isToday(dateString: string): boolean {
    if (!dateString) return false;
    try {
      let dateObj: Date;

      // Se já está no formato DD/MM/YYYY
      if (dateString.includes("/")) {
        const elementosData = dateString.split("/");
        if (elementosData.length === 3) {
          // Formato DD/MM/YYYY -> converter para MM/DD/YYYY para o Date
          const dia = elementosData[0];
          const mes = elementosData[1];
          const ano = elementosData[2];
          dateObj = new Date(`${mes}/${dia}/${ano}`);
        } else {
          dateObj = new Date(dateString);
        }
      } else {
        dateObj = new Date(dateString);
      }

      // Verificar se a data é válida
      if (isNaN(dateObj.getTime())) return false;

      const hoje = new Date();
      hoje.setHours(0, 0, 0, 0);
      dateObj.setHours(0, 0, 0, 0);

      return dateObj.getTime() === hoje.getTime();
    } catch {
      return false;
    }
  }

  // Funções para buscar informações de rota e montagem (adaptadas do CabGrid.tsx)
  async function getInfoRota(chCriacao: string, type: string, codigo: string) {
    try {
      console.log(`Buscando info rota para chCriacao: ${chCriacao}, type: ${type}, código: ${codigo}`);
      const response = await api.get(`/pedidos/infoRota/${chCriacao}/${type}/${codigo}`);
      if (response.status === 200) return response.data;
    } catch (error) {
      console.error('Erro ao buscar info rota:', error);
    }
    return null;
  }

  async function getInfoMontagem(documento: string) {
    try {
      const response = await api.get(`/pedidos/infoHorarioMontagem/${documento}`);
      if (response.status === 200) return response.data;
    } catch (error) {
      console.error('Erro ao buscar info montagem:', error);
    }
    return null;
  }

  // Buscar informações de rota e montagem para cada produto
  useEffect(() => {
    if (!orderInfo.order.pedidoDet || orderInfo.order.pedidoDet.length === 0) return;
    if (!orderInfo.order.docCliente) return;

    const transportadorasRoteiro: number[] = [8, 14, 15, 16, 17, 18];
    const transportadorasFrotaSP: number[] = [
      165,
      166,
      167,
      168,
      169,
      170,
      171,
      172,
      173,
      174,
      175,
      176,
      177,
      178,
      179,
      180,
      181,
      182,
      183,
      187,
      188
    ];
    const transportadorasAgendado: number[] = [55, 66, 67, 68];

    orderInfo.order.pedidoDet.forEach((product) => {
      const productLogs = orderInfo.logsEntrega.filter(
        (log) => log.chItemPed === product.chave && log.status === 314
      );

      if (productLogs.length === 0) return;

      const firstLog = productLogs[0];
      const isRoteiro = firstLog.isRoteiro ||
        (firstLog.transportadora && transportadorasRoteiro.includes(Number(firstLog.transportadora)));
      const isAgendada = firstLog.zDataAgendada ? true : (firstLog.transportadora && transportadorasAgendado.includes(Number(firstLog.transportadora)));
      const isFrotaSP = firstLog.transportadora && transportadorasFrotaSP.includes(Number(firstLog.transportadora));

      /* Buscar informação de rota se: 
      1. Roteiro: status 314, dtEntregaAg
      2. FrotaSp: status 314, zDataAgendada */
      if ((isRoteiro && firstLog.status === 314 && firstLog.dtEntregaAg && firstLog.dtEntregaAg !== '') || (isFrotaSP && firstLog.status === 314 && firstLog.zDataAgendada && firstLog.zDataAgendada !== '')) {
        let novaDataRota = null;
        if (isRoteiro && firstLog.dtEntregaAg) {
          novaDataRota = new Date(firstLog.dtEntregaAg);
        } else if (isFrotaSP && firstLog.zDataAgendada) {
          novaDataRota = new Date(firstLog.zDataAgendada);
        }

        if (!novaDataRota) return;

        const hoje = new Date();

        if (hoje.getHours() >= 9) {
          hoje.setHours(0, 0, 0, 0);

          const dia = ('0' + novaDataRota.getDate()).slice(-2);
          const mes = ('0' + (novaDataRota.getMonth() + 1)).slice(-2);
          const ano = novaDataRota.getFullYear();
          const dataRota = dia + '/' + mes + '/' + ano;

          const diaAtual = ('0' + hoje.getDate()).slice(-2);
          const mesAtual = ('0' + (hoje.getMonth() + 1)).slice(-2);
          const anoAtual = hoje.getFullYear();
          const dataAtual = diaAtual + '/' + mesAtual + '/' + anoAtual;

          if (((isRoteiro && dataRota === dataAtual) || isFrotaSP) && product.codigo) {
            const chCriacao = orderInfo.order.chCriacao?.toString() || "";
            const orderId = orderInfo.order.orderId || "";
            const type = chCriacao ? 'chCriacao' : 'orderId';
            const identifier = chCriacao || orderId;
            getInfoRota(identifier, type, product.codigo).then((result) => {
              if (result?.sucesso && result.dataFormatada === dataAtual) {
                setRotaInfo(prev => ({
                  ...prev,
                  [product.chave]: {
                    data: result.dataFormatada,
                    horario: result.horario
                  }
                }));
              }
            });
          }
        }
      }

      // Buscar informação de montagem se tiver dataMontagem
      if (firstLog.dtMontagem && firstLog.dtMontagem !== '') {
        const novaDataMontagem = new Date(firstLog.dtMontagem);
        const hoje = new Date();

        if (hoje.getHours() >= 9) {
          hoje.setHours(0, 0, 0, 0);

          const dia = ('0' + novaDataMontagem.getDate()).slice(-2);
          const mes = ('0' + (novaDataMontagem.getMonth() + 1)).slice(-2);
          const ano = novaDataMontagem.getFullYear();
          const dataMontagem = dia + '/' + mes + '/' + ano;

          const diaAtual = ('0' + hoje.getDate()).slice(-2);
          const mesAtual = ('0' + (hoje.getMonth() + 1)).slice(-2);
          const anoAtual = hoje.getFullYear();
          const dataAtual = diaAtual + '/' + mesAtual + '/' + anoAtual;

          if (dataMontagem === dataAtual && orderInfo.order.docCliente) {
            getInfoMontagem(orderInfo.order.docCliente).then((chaveMontagem) => {
              if (chaveMontagem?.dataFormatada === dataAtual && chaveMontagem.horario) {
                setMontagemInfo(prev => ({
                  ...prev,
                  [product.chave]: chaveMontagem.horario
                }));
              }
            });
          }
        }
      }
    });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [orderInfo.order.pedidoDet, orderInfo.logsEntrega, orderInfo.order.docCliente]);

  return (
    <div id="page-tracking">
      <div className="tracking-wrapper">
        {isLoading ? (
          <PrincipalLoader className="content-loader" />
        ) : (
          <>
            {/* Header */}
            <div className="tracking-header">
              <a
                href="https://www.abracasa.com.br/"
                target="_blank"
                rel="noreferrer noopener"
              >
                <img
                  className="tracking-logo"
                  src={logoCasa}
                  alt="Casa"
                />
              </a>
              <div className="tracking-header-actions">
                <div
                  className="back-home"
                  onClick={() => { window.location.href = "/meus-pedidos" }}
                >
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    viewBox="0 0 24 24"
                    fill="none"
                    stroke="currentColor"
                    strokeWidth="2"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    style={{ marginTop: 2.5 }}
                  >
                    <path d="M15 18l-6-6 6-6" />
                  </svg>
                  <span>Meus Pedidos</span>
                </div>
              </div>
            </div>

            {/* Order Info Header */}
            <Accordion className="product-accordion order-accordion">
              <AccordionSummary
                expandIcon={<ExpandMoreIcon className="accordion-expand-icon" />}
                aria-controls="order-info-content"
                id="order-info-header"
                className="product-accordion-summary order-accordion-summary"
              >
                <h2 className="order-number">
                  Pedido #{orderInfo.order.orderId || orderInfo.order.chCriacao}
                </h2>
              </AccordionSummary>
              <AccordionDetails className="product-accordion-details">
                <div className="tracking-order-header order-header-details">
                  <div className="order-header-left">
                    <div className="order-meta">
                      <span className="order-date">
                        Data do pedido: <strong>{formatDate(orderInfo.order.created_at)}</strong>
                      </span>
                      <span className="order-total">
                        Valor total: <strong>{formatCurrency(orderInfo.order.valor, true)}</strong>
                      </span>
                    </div>
                  </div>
                  <div className="order-header-right">
                    <div className="buyer-info">
                      <h3>Informações do Comprador</h3>
                      <p>Nome: {orderInfo.order.nomeCliente || "Não informado"}</p>
                      <p>Documento: {!orderInfo.order.docCliente ? "Não informado" : orderInfo.order.docCliente.length == 11 ? maskCpf(orderInfo.order.docCliente) : formatCpfCnpj(orderInfo.order.docCliente)}</p>
                      {orderInfo.order.arquiteto && (
                        <p>Arquiteto: {orderInfo.order.arquiteto}</p>
                      )}
                    </div>
                  </div>
                </div>
              </AccordionDetails>
            </Accordion>

            <ServicosTeaser />

            {loading && (
              <div className="tracking-progress">
                <LinearProgress color="secondary" style={{ backgroundColor: '#FBB813' }} />
              </div>
            )}

            {/* Products Section */}
            <div className="tracking-products">
              {orderInfo.order.pedidoDet && orderInfo.order.pedidoDet.length > 0 ? (
                (() => {
                  // Fallback compartilhado: pedidos com entrega hoje saem juntos no mesmo horário
                  const fallbackRotaData = Object.values(rotaInfo).find(
                    (info) => info?.data && info?.horario
                  );

                  return orderInfo.order.pedidoDet.map((product, index) => {
                  const productLogs = orderInfo.logsEntrega.filter(
                    (log) => log.chItemPed === product.chave
                  );

                  const firstLog = productLogs.length > 0 ? productLogs[0] : null;
                  const transportadorasRoteiro: number[] = [8, 14, 15, 16, 17, 18];
                  const transportadorasAgendado: number[] = [55, 66, 67, 68];

                  const isRoteiro = firstLog?.isRoteiro ||
                    (firstLog?.transportadora && transportadorasRoteiro.includes(Number(firstLog.transportadora)));
                  const isAgendada = firstLog?.zDataAgendada ? true :
                    (firstLog?.transportadora && transportadorasAgendado.includes(Number(firstLog.transportadora)));

                  const ownRotaData = rotaInfo[product.chave];
                  const dataEntregaProduto = firstLog
                    ? (firstLog.zDataAgendada || firstLog.dtEntregaAg || "")
                    : "";
                  const isEntregaHojeProduto = isToday(dataEntregaProduto);
                  // Mantém a consulta individual; usa horário de outro item só como fallback quando for entrega hoje
                  const rotaData =
                    ownRotaData?.data && ownRotaData?.horario
                      ? ownRotaData
                      : isEntregaHojeProduto
                        ? fallbackRotaData
                        : undefined;
                  const montagemHorario = montagemInfo[product.chave];

                  return (
                    <div key={index} className="product-card">
                      <Accordion
                        className="product-accordion"
                        expanded={!!expandedProducts[product.chave]}
                        onChange={(_, isExpanded) => setProductExpanded(product.chave, isExpanded)}
                      >
                        <AccordionSummary
                          expandIcon={<ExpandMoreIcon className="accordion-expand-icon" />}
                          aria-controls={`panel${index}-content`}
                          id={`panel${index}-header`}
                          className="product-accordion-summary"
                        >
                          {/* Product Info - Visível quando minimizado */}
                          <div className="product-info">
                            <div className="product-image">
                              <img
                                src={product.imageUrl ? getProductImage(product.imageUrl) : logoCasa}
                                alt={product.descricao}
                                onError={(e) => {
                                  (e.target as HTMLImageElement).src = logoCasa;
                                }}
                              />
                            </div>
                            <div className="product-details">
                              <h3 className="product-title">{product.descricao}</h3>
                              <div className="product-specs">
                                <span className="product-quantity">
                                  Quantidade: {Math.floor(Math.abs(product.quantidade))} un.
                                  {product.url && (
                                    <>
                                      <span style={{ marginLeft: 5, marginRight: 5 }}>|</span>
                                      <a href={product.url} target="_blank" style={{ textDecoration: "none", color: "var(--pink-abra)" }}>Ver detalhe</a>
                                    </>
                                  )}
                                </span>
                                <span className="product-price">
                                  Valor unitário: <strong>{formatCurrency(product.valorUnitario, false)}</strong>
                                </span>
                              </div>

                              {/* Informações de Entrega, Montagem e Impermeabilização */}
                              {firstLog && (() => {
                                const entregue = deliveredCouries.includes(firstLog.status) && firstLog.dataEntrega;
                                const showRotaInfo = rotaData && rotaData.data && rotaData.horario;
                                const showEntregaAg = !rotaData && !firstLog.isRetirada &&
                                  ((firstLog.dtEntregaAg && isRoteiro && !isAgendada) ||
                                    (firstLog.zDataAgendada && !isRoteiro && isAgendada));
                                const showEntregaAgOrPrevisao = showEntregaAg || (!showRotaInfo && !!orderInfo.order.previsaoEntrega);
                                const showRetirada = firstLog.isRetirada && firstLog.dtRetirada;
                                const showMontagem = firstLog.dtMontagem;
                                const showImpermeabilizacao = firstLog.dtImpermeabilizacao;
                                const entregaAgendadaDate = firstLog.zDataAgendada || firstLog.dtEntregaAg || "";
                                const diffDaysPedidoEntregaAg = getDaysDifference(orderInfo.order.created_at, entregaAgendadaDate);
                                const diffDaysEntregaAgProgramacao = getDaysDifference(entregaAgendadaDate, firstLog.dtProgramacaoErp || "");
                                const shouldUsePrevisaoEntrega = !!(
                                  orderInfo.order.previsaoEntrega &&
                                  diffDaysPedidoEntregaAg !== null &&
                                  diffDaysPedidoEntregaAg <= 2 &&
                                  (
                                    diffDaysEntregaAgProgramacao === null ||
                                    Math.abs(diffDaysEntregaAgProgramacao) < 3
                                  )
                                );
                                const erpDeadlineDate = shouldUsePrevisaoEntrega
                                  ? orderInfo.order.previsaoEntrega
                                  : (firstLog.dtProgramacaoErp || orderInfo.order.previsaoEntrega || "");
                                const showErpDeadline = !!(
                                  showEntregaAg &&
                                  !showRetirada &&
                                  diffDaysPedidoEntregaAg !== null &&
                                  diffDaysPedidoEntregaAg <= 2 &&
                                  !shouldUsePrevisaoEntrega &&
                                  erpDeadlineDate
                                );
                                const blockScheduling = !!(
                                  firstLog.chTranspERP &&
                                  blockedDeliveryTransp.includes(firstLog.chTranspERP)
                                );

                                const isHelloTransportadora = firstLog.transportadora &&
                                  (firstLog.transportadora == '122' || firstLog.transportadora == '23' || firstLog.transportadora == '50' || firstLog.transportadora == '51' || firstLog.transportadora == '52' || firstLog.transportadora == '53' || firstLog.transportadora == '54' || firstLog.transportadora == '55' || firstLog.transportadora == '66' || firstLog.transportadora == '67' || firstLog.transportadora == '68' || firstLog.transportadora == '70' || firstLog.transportadora == '75' || firstLog.transportadora == '76' || firstLog.transportadora == '77' || firstLog.transportadora == '78' || firstLog.transportadora == '79' || firstLog.transportadora == '80' || firstLog.transportadora == '81' || firstLog.transportadora == '82' || firstLog.transportadora == '83' || firstLog.transportadora == '84' || firstLog.transportadora == '92' || firstLog.transportadora == '93' || firstLog.transportadora == '99' || firstLog.transportadora == '100' || firstLog.transportadora == '101' || firstLog.transportadora == '102' || firstLog.transportadora == '103');
                                const showHelloInfo = isHelloTransportadora;

                                const hasAnySchedule = showRotaInfo || showEntregaAgOrPrevisao || showRetirada ||
                                  showMontagem || showImpermeabilizacao || showHelloInfo || blockScheduling;

                                if (!hasAnySchedule) return null;

                                return (
                                  <div className="product-schedule-info">
                                    {/* Entrega sem modalidade de agendamento */}
                                    {!entregue && blockScheduling && (() => {
                                      return (
                                        <div className="schedule-item">
                                          <img src={iconEntrega} alt="entrega" className="schedule-icon" />
                                          <div className="schedule-text">
                                            <span className="schedule-label">
                                              Modalidade sem direito a agendamento de entrega!
                                            </span>
                                          </div>
                                        </div>
                                      );
                                    })()}

                                    {/* Entrega Agendada com horário da rota */}
                                    {!entregue && showRotaInfo && (() => {
                                      const dataEntrega = firstLog.zDataAgendada || firstLog.dtEntregaAg || "";
                                      const isEntregaHoje = isToday(dataEntrega);

                                      return (
                                        <div className="schedule-item">
                                          <img src={iconEntrega} alt="entrega" className="schedule-icon" />
                                          <div className="schedule-text">
                                            <span className="schedule-label">
                                              {isEntregaHoje ? "Seu pedido chegará hoje!" : "Entrega Agendada"}
                                            </span>
                                            <strong>
                                              {rotaData?.data} {rotaData?.horario}
                                            </strong>
                                          </div>
                                        </div>
                                      );
                                    })()}

                                    {/* Entrega Agendada sem horário */}
                                    {!entregue && !showRotaInfo && (showEntregaAg || orderInfo.order.previsaoEntrega) && !showRetirada && (() => {
                                      const dataEntrega = (firstLog.zDataAgendada || firstLog.dtEntregaAg || "");
                                      const dataLimiteEntrega = (orderInfo.order.previsaoEntrega || "");

                                      const isEntregaHoje = isToday(dataEntrega);
                                      let entregaLabel = "";

                                      if (dataEntrega) {
                                        entregaLabel = isEntregaHoje ? "Seu pedido chegará hoje!" : "Entrega Agendada";
                                      } else if (dataLimiteEntrega) {
                                        entregaLabel = "Data Limite de Entrega";
                                      }

                                      return (
                                        <div className="schedule-item">
                                          <img src={iconEntrega} alt="entrega" className="schedule-icon" />
                                          <div className="schedule-text">
                                            <span className="schedule-label">{entregaLabel}</span>
                                            <strong>{formatDateFromString(dataEntrega || dataLimiteEntrega)}</strong>
                                          </div>
                                        </div>
                                      );
                                    })()}

                                    {entregue && firstLog.dataEntrega && (() => {
                                      return (
                                        <div className="schedule-item">
                                          <img src={iconEntrega} alt="entrega" className="schedule-icon" />
                                          <div className="schedule-text">
                                            <span className="schedule-label">Pedido entregue em</span>
                                            <strong>{formatDateFromString(firstLog.dataEntrega)}</strong>
                                          </div>
                                        </div>
                                      );
                                    })()}

                                    {/* {showErpDeadline && (
                                      <div className="schedule-item">
                                        <img src={iconEntrega} alt="entrega" className="schedule-icon" />
                                        <div className="schedule-text">
                                          <span className="schedule-label">Data limite de entrega</span>
                                          <strong>{formatDateFromString(erpDeadlineDate)}</strong>
                                        </div>
                                      </div>
                                    )} */}

                                    {/* Retirada */}
                                    {showRetirada && (
                                      <div className="schedule-item">
                                        <img src={iconEntrega} alt="retirada" className="schedule-icon" />
                                        <div className="schedule-text">
                                          <span className="schedule-label">Pronto para retirada em</span>
                                          <strong>{formatDateFromString(firstLog.dtRetirada || "")}</strong>
                                        </div>
                                      </div>
                                    )}

                                    {/* Montagem */}
                                    {showMontagem && (() => {
                                      const isMontagemHoje = isToday(firstLog.dtMontagem);

                                      return (
                                        <div className="schedule-item">
                                          <img src={iconMontagem} alt="montagem" className="schedule-icon" />
                                          <div className="schedule-text">
                                            <span className="schedule-label">
                                              {isMontagemHoje ? "A montagem será realizada hoje!" : "Montagem"}
                                            </span>
                                            <strong>
                                              {formatDateFromString(firstLog.dtMontagem)}
                                              {montagemHorario && ` - ${montagemHorario}`}
                                            </strong>
                                          </div>
                                        </div>
                                      );
                                    })()}

                                    {/* Impermeabilização */}
                                    {showImpermeabilizacao && (() => {
                                      const isImpermeabilizacaoHoje = isToday(firstLog.dtImpermeabilizacao);

                                      return (
                                        <div className="schedule-item">
                                          <img
                                            src={getImpermeabilizacaoIcon(product.descricao)}
                                            alt="impermeabilização"
                                            className="schedule-icon"
                                          />
                                          <div className="schedule-text">
                                            <span className="schedule-label">
                                              {isImpermeabilizacaoHoje ? "A impermeabilização será realizada hoje!" : "Impermeabilização"}
                                            </span>
                                            <strong>{formatDateFromString(firstLog.dtImpermeabilizacao)}</strong>
                                          </div>
                                        </div>
                                      );
                                    })()}

                                    {/* Regras da transportadora Hello (condicionado apenas à transportadora) */}
                                    {showHelloInfo && (
                                      <button
                                        type="button"
                                        className="schedule-item hello-rules-card"
                                        onClick={(event) => {
                                          event.stopPropagation();
                                          setOpenHelloModal(true);
                                        }}
                                      >
                                        <img src={iconEntrega} alt="hello" className="schedule-icon" />
                                        <div className="schedule-text">
                                          <span className="schedule-label">
                                            Regras da transportadora
                                          </span>
                                          <strong>Ver regras</strong>
                                        </div>
                                      </button>
                                    )}
                                  </div>
                                );
                              })()}
                            </div>
                          </div>
                        </AccordionSummary>
                        <AccordionDetails className="product-accordion-details">
                          <div className="accordion-content-wrapper">
                            {/* Tracking Timeline */}
                            {productLogs.length > 0 && (
                              <div className="tracking-timeline">
                                <h4 className="timeline-title">Histórico de Rastreio</h4>
                                <div className="timeline-container">
                                  {productLogs
                                    .sort((a, b) => {
                                      const dateA = a.created_at ? new Date(a.created_at).getTime() : 0;
                                      const dateB = b.created_at ? new Date(b.created_at).getTime() : 0;
                                      return dateB - dateA;
                                    })
                                    .map((log, logIndex) => (
                                      <div key={logIndex} className="timeline-item">
                                        <div className="timeline-marker">
                                          <span className="timeline-icon">{getStatusIcon(log.status)}</span>
                                        </div>
                                        <div className="timeline-content">
                                          <div className="timeline-description">
                                            <strong>{capitalizeWords(log.descricao) + (
                                              log.dataEntrega && (deliveredCouries.includes(log.status))
                                                ? ` Em ${formatDateFromString(log.dataEntrega)}`
                                                : '')}</strong>
                                            {log.codigo && (
                                              <span className="timeline-transport">
                                                Transportadora: {log.codigo}
                                              </span>
                                            )}
                                            {log.observacao && (
                                              <p className="timeline-observation">{log.observacao}</p>
                                            )}
                                          </div>
                                          <div className="timeline-date">
                                            {formatDateTime(log.created_at)}
                                          </div>
                                          {log.linkRastreioTransp && (
                                            <a
                                              href={log.linkRastreioTransp}
                                              target="_blank"
                                              rel="noopener noreferrer"
                                              className="tracking-link"
                                            >
                                              Rastrear na transportadora →
                                            </a>
                                          )}
                                        </div>
                                      </div>
                                    ))}
                                </div>
                              </div>
                            )}

                            {/* Downloads Section */}
                            {(() => {
                              const hasNFE = productLogs.some(log => (log.cnpjEmissorNFE ? cnpjsToNFE.includes(log.cnpjEmissorNFE) : false) || log.linkNFE);
                              const hasCert = certLinks[product.chave];
                              const hasManual = manualLinks[product.chave];
                              const showDownloads = hasNFE || hasCert || hasManual;

                              if (!showDownloads) return null;

                              return (
                                <div className="product-downloads">
                                  <h4 className="downloads-title">Documentos e Downloads</h4>
                                  <div className="downloads-grid">
                                    {/* Nota Fiscal */}
                                    {hasNFE && (() => {
                                      const logWithNFE = productLogs.find(log => log.chNFE);
                                      const hasDirectLink = logWithNFE?.linkNFE || nfeLinks[product.chave];
                                      const canFetch = logWithNFE && canFetchNFE(logWithNFE);
                                      const isLoading = nfeLoading[product.chave];

                                      return (
                                        <div className="download-item">
                                          <DescriptionIcon className="download-icon" />
                                          <div className="download-info">
                                            <strong>Nota Fiscal</strong>
                                            <span>Download da NF-e</span>
                                          </div>
                                          {hasDirectLink ? (
                                            <a
                                              href={logWithNFE?.linkNFE || nfeLinks[product.chave]}
                                              target="_blank"
                                              rel="noopener noreferrer"
                                              className="download-button"
                                            >
                                              <GetAppIcon />
                                              Baixar
                                            </a>
                                          ) : canFetch ? (
                                            <button
                                              className="download-button"
                                              onClick={() => {
                                                if (logWithNFE) {
                                                  getNFE(
                                                    logWithNFE.chave,
                                                    logWithNFE.chItemPed,
                                                    logWithNFE.transportadora || "",
                                                    product.chave
                                                  );
                                                }
                                              }}
                                              disabled={isLoading}
                                            >
                                              <GetAppIcon />
                                              {isLoading ? "Buscando..." : "Baixar"}
                                            </button>
                                          ) : (
                                            <button className="download-button" disabled>
                                              <GetAppIcon />
                                              Indisponível
                                            </button>
                                          )}
                                        </div>
                                      );
                                    })()}

                                    {/* Certificado de Garantia - Exibe apenas se tiver link retornado */}
                                    {hasCert && (
                                      <div className="download-item">
                                        <VerifiedUserIcon className="download-icon" />
                                        <div className="download-info">
                                          <strong>Certificado de Garantia</strong>
                                          <span>Documento de garantia do produto</span>
                                        </div>
                                        <button
                                          className="download-button"
                                          onClick={() => {
                                            window.open(certLinks[product.chave], "_blank");
                                          }}
                                        >
                                          <GetAppIcon />
                                          Baixar
                                        </button>
                                      </div>
                                    )}

                                    {/* Manual de Montagem - Exibe apenas se tiver link retornado */}
                                    {hasManual && (
                                      <div className="download-item">
                                        <BuildIcon className="download-icon" />
                                        <div className="download-info">
                                          <strong>Manual de Montagem</strong>
                                          <span>Instruções de montagem</span>
                                        </div>
                                        <button
                                          className="download-button"
                                          onClick={() => {
                                            window.open(manualLinks[product.chave], "_blank");
                                          }}
                                        >
                                          <GetAppIcon />
                                          Baixar
                                        </button>
                                      </div>
                                    )}
                                  </div>
                                </div>
                              );
                            })()}

                            <button
                              type="button"
                              className="product-accordion-collapse"
                              onClick={() => collapseProductFromFooter(product.chave, index)}
                              aria-label="Minimizar detalhes do produto"
                            >
                              <ExpandMoreIcon className="accordion-expand-icon" />
                            </button>
                          </div>
                        </AccordionDetails>
                      </Accordion>
                    </div>
                  );
                });
                })()
              ) : (
                !loading && (
                  <div className="no-products">
                    <p>Em breve seus produtos aparecerão aqui.</p>
                  </div>
                )
              )}
            </div>

            <ServicosAbraCasa context="tracking" />

            {/* Contact Footer */}
            <div className="tracking-footer">
              <h3 className="footer-title">Precisa de Ajuda?</h3>
              <p className="footer-subtitle">Entre em contato conosco pelo WhatsApp</p>
              <div className="contact-buttons">
                {contactReasons.map((reason, index) => (
                  <button
                    key={index}
                    className="contact-button"
                    onClick={() => openWhatsApp(reason.message)}
                  >
                    <WhatsAppIcon />
                    {reason.title}
                  </button>
                ))}
              </div>
              <div className="footer-info">
                <p>
                  WhatsApp: <strong>(21) 97117-4398</strong>
                </p>
              </div>
            </div>

            <button
              type="button"
              className="whatsapp-fab"
              onClick={() => openWhatsApp("Olá! Preciso de ajuda.")}
              aria-label="Preciso de ajuda"
            >
              <WhatsAppIcon />
            </button>
          </>
        )}
      </div>
      {openHelloModal && (
        <div
          className="hello-modal-overlay"
          onClick={() => setOpenHelloModal(false)}
        >
          <div
            className="hello-modal"
            onClick={(event) => event.stopPropagation()}
          >
            <h2 className="hello-modal-title">Regras da transportadora</h2>
            <ul className="hello-modal-list">
              <li>Horário de entrega: das 08h00 às 18h00.</li>
              <li>Tempo de espera no local: a equipe aguarda até 15 minutos.</li>
              <li>Os entregadores não cobram nenhuma taxa no momento da entrega para subidas pela escada.</li>
              <li>Caso a entrega não possa ser realizada por motivo relacionado ao cliente, uma nova tentativa será feita em até 6 dias úteis para capital e até 14 dias úteis para interior.</li>
              <li>Quando o produto não couber no elevador, a equipe realiza o transporte por escadas, limitado em até 6 lances.</li>
              <li>Se o item não puder ser transportado até o ambiente final, a entrega será concluída em um local alternativo definido pelo cliente ou responsável (como garagem, portaria etc.).</li>
              <li>Ao final do serviço, a Hello solicita a vistoria dos produtos e a assinatura do responsável, confirmando que estão em perfeitas condições.</li>
              <li>Clientes que não contrataram no ato da compra o tipo "entrega agendada" não podem escolher a data; o agendamento fica a critério do roteiro da transportadora.</li>
              <li>Caso, mesmo após as tentativas previstas, não seja possível realizar a entrega, o cliente deverá fazer a retirada do produto diretamente na loja Abra Casa Pinheiros, podendo haver cobrança de taxa extra.</li>
            </ul>
            <button
              type="button"
              className="hello-modal-close"
              onClick={() => setOpenHelloModal(false)}
            >
              Fechar
            </button>
          </div>
        </div>
      )}
    </div>
  );
}

export default Tracking;

